import { appConfig } from '@/shared/config/app-config';

export type RequestPasswordResetResult = { ok: true } | { ok: false };

export async function requestPasswordReset(input: {
    email: string;
}): Promise<RequestPasswordResetResult> {
    try {
        const response = await fetch(`${appConfig.apiUrl}/auth/forgot-password`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: input.email }),
        });
        return response.ok ? { ok: true } : { ok: false };
    } catch {
        return { ok: false };
    }
}
